import { useCallback, useState } from "react";
import config from "../config";
import useRazorpay from "react-razorpay";
import { Button, message } from "antd";
import Loader from "../components/loader";
import { useLoader } from "../provider/PricingLoaderProvider";
import { useDispatch, useSelector } from "react-redux";
import { getShopDetails } from "../service/service";
import moment from "moment";

const getOrderId = async (payload) => {
  return new Promise((res, rej) => {
    fetch(`${config.ApiGateway}/razorPayCreateOrder`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((val) => res(val))
      .catch((err) => rej(err));
  });
};

const paymentGatewayFunc = (orderDetails, amount, Razorpay, setLoader) => {
  return new Promise((resolve, rej) => {
    const options = {
      key: config.razorKey,
      image: "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/appLogo76.png",
      amount: amount * 100,
      currency: "INR",
      name: "Ghoshak",
      description: "Ghoshak Package",
      method: "upi",
      order_id: orderDetails.id,
      handler: async (res) => {
        setLoader(true);
        const result = await verifyPayment(res);
        resolve({
          ...result,
          ...res,
        });
      },
      theme: { color: "#CA1D2C" },
    };
    const rzpay = new Razorpay(options);
    rzpay.open();
    rzpay.on("payment.failed", function (response) {
      alert("Payment Failed");
      rej({
        status: "failed",
      });
      setLoader(false);
    });
  });
};

const verifyPayment = async (payload) => {
  try {
    const response = await fetch(`${config.ApiGateway}/razorPayVerify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    console.log("verifyPayment", data);
    return data;
  } catch (err) {
    console.log("getOrderId Err ", err);
  }
};

const buyPackages = async (payload) => {
  try {
    const response = await fetch(`${config.ApiGateway}/buyPackages`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("buyPackages Err ", error);
  }
};

export default function PaymentGateway({
  amount = "",
  payload = {},
  setCartList = () => {},
  onClose = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const Razorpay = useRazorpay();
  const [, setLoader] = useLoader();
  const dispatch = useDispatch();
  const shopData = useSelector((state) => state.shopDetails);
  const handlePayment = async () => {
    const orderDetails = await getOrderId({
      orderAmount: amount,
    });
    try {
      const paymentStatus = await paymentGatewayFunc(
        orderDetails,
        amount,
        Razorpay,
        setLoader
      );
      console.log("paymentStatus", paymentStatus);
      if (paymentStatus.status === "success") {
        const updatePayload = {
          ...payload,
          paymentDetails: paymentStatus,
        };
        console.log("updatePayload", updatePayload);
        const data = await buyPackages(updatePayload);
        console.log("buyPackages", data);
        if (data.status === "SUCCESS") {
          onClose();
          message.success(data.message);
          const isSmsPackage = updatePayload.items.find(
            (i) => i.packageType === "sms"
          );
          if (isSmsPackage) {
            dispatch({
              type: "SMS_PACKAGE",
              payload: {
                smsCount: shopData.smsCount
                  ? shopData.smsCount + isSmsPackage.count
                  : isSmsPackage.count,
                smsExpiryDate: moment().add(1, "year").format("YYYY-MM-DD"),
                smsPackage: "yes",
              },
            });
          }
        } else if (data.status === "ERROR") {
          onClose();
          message.error(data.message);
        }
      } else if (paymentGatewayFunc.status === "failed") {
        message.error("Payment Failed");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setCartList([]);
      setLoader(false);
    }
  };
  console.log("loading", loading);

  return (
    <Button
      type="primary"
      style={{
        width: "200px",
      }}
      size="large"
      onClick={handlePayment}
    >
      Buy Package
    </Button>
  );
}
